import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UserService } from '../../../../../services/user.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SchoolService } from '../../../../../services/school.service';
import { ClassService } from '../../../../../services/class.service';
import { UserStatus, UserType } from '../../../../../model/Const';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CoursewareService } from '../../../../../services/courseware.service';
import { HWResourceService } from '../../../../../services/huawei-resource.service';
import { SyllabusService } from '../../../../../services/syllabus.service';
import { TagsService } from '../../../../../services/tags.service';
import { ExerciseService } from '../../../../../services/exercise.service';
import { MediaV2Service } from '../../../../../services/media-v2.service';
import { NzCascaderOption } from 'ng-zorro-antd/cascader';
import { Subscription } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  DriveClipboard,
  DriveClipboardItem,
  DriveContentState,
  DriveFileActionEvent,
  DriveFileCard,
  DriveFolderActionEvent,
  DriveFolderCard,
  DriveFolderRef,
  DriveNavigationState,
  DriveSelectedItem,
  DriveSelectionToolbarEvent,
  DriveTreeNode,
  ResourceFilter,
  SyllabusTreeNode,
} from './file-manager/drive.types';
import {
  buildDriveQuery,
  buildMoveTargetTreeNodes,
  buildPathIdsFromFolder,
  collectDescendantIds,
  getChildrenAtPath,
  getResourceCoverUrl,
  hasActiveThemes,
  parseDrivePathParam,
  resolveDriveFolderId,
  resolveDriveFolderRef,
  syllabusToNzTree,
  validatePathIdsInSyllabus,
} from './file-manager/drive.utils';
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import { pathIdsToDrivePathParam } from '../resource-drive-path.util';

interface ResourceListStatePayload {
  resourceType: string;
  view?: 'list' | 'drive';
  filter: ResourceFilter;
  levelSelectValues?: string[];
  driveNavPathIds?: number[];
  driveThemes?: Record<string, unknown>;
}


@Component({
  selector: 'app-admin-book-resource-courseware-list',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  standalone: false,
})
export class AdminBookResourceCoursewareListComponent implements OnInit, OnDestroy {
  dataSet: any[] = [];
  totalNum = 0;
  totalClasses = 0;
  currentPageIndex = 1;
  user: any = null;
  constUserType = UserType;
  isLoading = false;
  isLoadingAttr = false;
  pageTitle: string | undefined = '';

  bookAttrs: any = {};
  themeKeyValueItems: any = {};
  syllabusKeyValueItems: any = {};
  rootSyllabusThemes: any = [];
  subSyllabusThemes: any = [];

  // 多级筛选相关属性
  multiLevelFilters: any[] = []; // 存储所有层级的筛选器配置
  currentLevelOptions: any[] = []; // 当前层级的选项

  currentSyllabusId = 0;
  currentCourseId = 0;
  indeterminate = false;

  // @Output() onItemSelected = new EventEmitter();
  // @Input() refPage: AdminBookResourceCoursewareListComponent|null = null;
  @Input() resourceType = '';

  @Input() itemSelection!: Map<string|number, any>;
  @Output() itemSelectionChange = new EventEmitter<Map<string|number, any>>();

  @Input() single = false;
  @Input() activeView: 'list' | 'drive' = 'drive';

  singleItemSelect = null;

  levelSelectOptions: NzCascaderOption[] | null = null;
  levelSelectValues: string[] = [];
  private readonly listStatePrefix = 'admin:v3:resource:list-state';
  private readonly listRestorePrefix = 'admin:v3:resource:list-restore';
  private readonly listRestoreMaxAgeMs = 120 * 60 * 1000;
  private ignoreNextTableQueryParams = false;
  private routerEventsSubscription: Subscription | null = null;
  private queryParamsSubscription: Subscription | null = null;
  private categoryInflight: Promise<any> | null = null;
  private driveLoadSeq = 0;
  private syllabusIdToNode = new Map<number, SyllabusTreeNode>();
  private restoredFromPayload = false;
  destroyed = false;

  driveNav: DriveNavigationState = { pathIds: [] };
  driveFolderCards: DriveFolderCard[] = [];
  driveFileCards: DriveFileCard[] = [];
  driveBreadcrumb: { id: number; name: string }[] = [];
  driveTotal = 0;
  driveContentState: DriveContentState = 'loading';
  driveSidebarError: string | null = null;
  driveFilesLoadError: string | null = null;
  driveThemesDrawerVisible = false;
  driveThemes: Record<string, unknown> = {};
  driveSidebarExpandedKeys: string[] = [];
  driveTreeNodes: DriveTreeNode[] = [];

  filter: any = {
    pageSize: 10,
    pageIndex: 1,
    name: '',
    syllabus_id: '',
    course_id: '',
    themes: {
    },
    reserve3: '',
    // 动态多级筛选字段
    level_filters: {},
    // created_on: '',
  };
  host = '';
  protocol = '';
  bucket = '';

  mainService!: ExerciseService|CoursewareService|MediaV2Service;

  // 弹框相关属性
  isEditSeqModalVisible = false;
  currentEditRow: any = null;
  editSeqValue = 0;
  originalSeqValue = 0; // 保存点击时的原始排序号

  isDriveRenameModalVisible = false;
  driveRenameLoading = false;
  driveRenameValue = '';
  driveRenameNameDuplicated = false;
  driveFolderEditCover = '';
  private driveFolderEditCoverOriginal = '';
  driveRenameTarget: { type: 'file' | 'folder'; id: number; name: string; folder?: DriveFolderCard } | null = null;

  isDriveMoveModalVisible = false;
  driveMoveLoading = false;
  driveMoveTreeLoading = false;
  private driveMovePrepareSeq = 0;
  driveMoveTarget: {
    items: Array<{
      type: 'file' | 'folder';
      id: number;
      name: string;
      folder?: DriveFolderCard;
      fromFolderId?: number | null;
    }>;
  } | null = null;
  driveMoveTreeNodes: DriveTreeNode[] = [];
  driveMoveSelectedFolderId: number | null = null;
  driveMoveSelectedFolderName = '';
  driveMoveExpandedKeys: string[] = [];

  driveClipboard: DriveClipboard | null = null;
  driveSelectionResetToken = 0;
  drivePasteLoading = false;

  isDriveCreateFolderModalVisible = false;
  driveCreateFolderLoading = false;
  driveCreateFolderValue = '';
  driveCreateFolderNameDuplicated = false;

  // setOfCheckedId = new Set<number>();



  constructor(private userService: UserService,
              private clsService: ClassService,
              private schoolService: SchoolService,
              private coursewareService: CoursewareService,
              private exerciseService: ExerciseService,
              private syllabusService: SyllabusService,
              private tagsService: TagsService,
              private mediaService: MediaV2Service,
              private activatedRoute: ActivatedRoute ,
              private router: Router ,
              private nzMessageService: NzMessageService,
              private modalService: NzModalService) {
    this.user = this.userService.getUserInfo();
    const u = new URL(window.location.href);
    console.log('AdminBookResourceCoursewareListComponent');
    this.protocol = u.protocol;
    this.host = HWResourceService.cdnHost;
    // this.bucket = HWResourceService.bucketPath;

    this.activatedRoute.title.subscribe({
      next: (title) => {
        this.pageTitle = title;
      }
    });
  }

  onLevelClear(event: any) {
    console.log('onLevelClear', event);
  }

  onLevelChanges(values: string[]): void {
    console.log(values, this.levelSelectValues);
    if (values.length > 0) {
      this.filter.path = values.join('/');
    } else {
      this.filter.path = '';
      this.filter.course_id = '';
      this.filter.syllabus_id = '';
    }
  }

  updateCheckedSet(item: any, checked: boolean): void {
    if (!this.itemSelection) {
      return;
    }
    if (checked) {
      this.itemSelection.set(item.id, item);
    } else {
      this.itemSelection.delete(item.id);
    }
  }
  onItemChecked(item: any, checked: boolean): void {
    if (!this.itemSelection) {
      return;
    }
    this.updateCheckedSet(item, checked);
  }




  get titleName() {
    let title = '';
    if (this.resourceType === 'cartoon') {
      title = '绘本';
    } else if (this.resourceType === 'book') {
      title = '教材';
    } else if (this.resourceType === 'audio') {
      title = '音频';
    } else if (this.resourceType === 'video') {
      title = '视频';
    } else if (this.resourceType === 'exercise') {
      title = '练习';
    }
    return title;
  }
  changeStatus($event: any, row: any ) {
    console.log('changeStatus', $event, row);
    let enabled = 0;
    if ($event) {
      enabled = 1;
    }
    row.enabled = enabled;
    row.reserve3 = enabled;
    console.log('changeStatus reserve3', enabled);
    this.isLoading = true;
    this.mainService.save(this.resourceType, {id: row.id, reserve3: enabled, enabled }).then(() => {
      this.isLoading = false;
    }).catch((err: any) => {
      this.nzMessageService.error(err.message || 'System Error');
      this.isLoading = false;
    });

  }

  getAddPageQueryParams(): Record<string, string | number> {
    const params: Record<string, string | number> = { tabIndex: 0 };
    const drivePath = pathIdsToDrivePathParam(this.driveNav.pathIds);
    if (
      (this.resourceType === 'audio' || this.resourceType === 'video')
      && this.activeView === 'drive'
      && drivePath
    ) {
      params['path'] = drivePath;
    }
    return params;
  }

  changeCategory(syllabus_id: number) {
    this.filter.course_id = '';
    this.filter.syllabus_id = syllabus_id;
    // 清除所有后续层级的选择
    this.filter.level_filters = {};

    if (!syllabus_id) {
      this.rootSyllabusThemes.length = 0;
      this.subSyllabusThemes.length = 0;
      // 清除多级筛选器的选项
      for (let i = 1; i < this.multiLevelFilters.length; i++) {
        this.multiLevelFilters[i].options = [];
      }
      return;
    }

    const a = this.syllabusKeyValueItems[syllabus_id];
    const root_themes = this.bookAttrs.themes.filter((s: any) => {
      return s.syllabus_id === syllabus_id;
    });

    console.log('chang syllabus', syllabus_id, root_themes);
    this.rootSyllabusThemes = root_themes;

    // 更新多级筛选器第二级的选项
    if (this.multiLevelFilters.length > 1) {
      this.multiLevelFilters[1].options = this.getChildrenByParentId(syllabus_id);
      // 更新层级名称
      this.updateLevelName(0, syllabus_id);
    }

    // 确保第三级及以后的筛选器被重置
    for (let i = 2; i < this.multiLevelFilters.length; i++) {
      this.multiLevelFilters[i].options = [];
    }

    console.log('changeCategory - 重置后的多级筛选器状态:', this.multiLevelFilters.map(f => ({
      level: f.level,
      name: f.name,
      optionsCount: f.options.length
    })));
  }

  changeSubCategory(course_id: number) {
    this.filter.course_id = course_id;
    // 清除后续层级的选择
    for (let i = 2; i < this.multiLevelFilters.length; i++) {
      this.filter.level_filters[`level_${i}`] = '';
      this.multiLevelFilters[i].options = [];
    }

    if (!course_id) {
      this.subSyllabusThemes.length = 0;
      // 清空第三级及以后的选项，确保它们被隐藏
      for (let i = 2; i < this.multiLevelFilters.length; i++) {
        this.multiLevelFilters[i].options = [];
      }
      return;
    }

    const sub_themes = this.bookAttrs.themes.filter((s: any) => {
      return s.syllabus_id === course_id;
    });
    console.log('chang course', course_id, sub_themes);
    this.subSyllabusThemes = sub_themes;

    // 更新多级筛选器第三级的选项
    if (this.multiLevelFilters.length > 2) {
      this.multiLevelFilters[2].options = this.getChildrenByParentId(course_id);
      // 更新层级名称
      this.updateLevelName(1, course_id);
    }
  }

  /**
   * 处理多级筛选变化
   * @param level 当前层级（从0开始）
   * @param value 选中的值
   */
  changeLevelFilter(level: number, value: number) {
    // 设置当前层级的筛选值
    this.filter.level_filters[`level_${level}`] = value;

    // 清除后续层级的选择和选项
    for (let i = level + 1; i < this.multiLevelFilters.length; i++) {
      this.filter.level_filters[`level_${i}`] = '';
      this.multiLevelFilters[i].options = [];
    }

    // 如果清空了当前选择，则清除后续所有层级
    if (!value) {
      // 只清除后续层级的选项，不清除当前层级的选项
      // 这样当前层级会保持显示状态
      for (let i = level + 1; i < this.multiLevelFilters.length; i++) {
        this.filter.level_filters[`level_${i}`] = '';
        this.multiLevelFilters[i].options = [];
      }

      // 如果是第三级被清空，需要重新加载第三级的选项
      if (level === 2 && this.filter.course_id) {
        this.multiLevelFilters[2].options = this.getChildrenByParentId(this.filter.course_id);
        console.log('第三级被清空，重新加载选项:', this.multiLevelFilters[2].options);
      }

      console.log('changeLevelFilter - 清空选择后的状态:', {
        level,
        value,
        thirdLevelOptions: this.multiLevelFilters[2]?.options?.length || 0,
        courseId: this.filter.course_id
      });

      return;
    }

    // 更新层级名称
    this.updateLevelName(level, value);

    // 获取下一层级的选项
    this.loadNextLevelOptions(level, value);
  }

  /**
   * 加载下一层级的选项
   * @param currentLevel 当前层级
   * @param selectedValue 当前选中的值
   */
  loadNextLevelOptions(currentLevel: number, selectedValue: number) {
    const nextLevel = currentLevel + 1;

    // 如果已经是最后一级，不需要加载下一级
    if (nextLevel >= this.multiLevelFilters.length) {
      return;
    }

    // 根据当前选择的值，从树形结构中获取子节点
    const children = this.getChildrenByParentId(selectedValue);

    // 更新下一级的选项
    this.multiLevelFilters[nextLevel].options = children;
  }

  /**
   * 根据父节点ID获取子节点
   * @param parentId 父节点ID
   * @returns 子节点数组
   */
  getChildrenByParentId(parentId: number): any[] {
    // 从syllabus树形结构中查找子节点
    const findChildren = (nodes: any[], parentId: number): any[] => {
      for (const node of nodes) {
        if (node.id === parentId && node.children) {
          return node.children;
        }
        if (node.children) {
          const result = findChildren(node.children, parentId);
          if (result.length > 0) {
            return result;
          }
        }
      }
      return [];
    };

    return findChildren(this.bookAttrs.syllabus, parentId);
  }

  /**
   * 初始化多级筛选器
   */
  initializeMultiLevelFilters() {
    this.multiLevelFilters = [];

    // 第一级：分类（syllabus）
    this.multiLevelFilters.push({
      level: 0,
      name: '分类',
      field: 'syllabus_id',
      options: this.bookAttrs.syllabus || [],
      placeholder: '分类'
    });

    // 第二级：大纲（course）
    this.multiLevelFilters.push({
      level: 1,
      name: '大纲',
      field: 'course_id',
      options: [],
      placeholder: '大纲'
    });

    // 动态添加更多层级（最多支持5级）
    for (let i = 2; i < 5; i++) {
      this.multiLevelFilters.push({
        level: i,
        name: `级别${i + 1}`,
        field: `level_${i}`,
        options: [],
        placeholder: `级别${i + 1}`
      });
    }
  }

  /**
   * 根据选中的父节点更新子节点的名称
   * @param level 当前层级
   * @param selectedValue 选中的值
   */
  updateLevelName(level: number, selectedValue: number) {
    if (level >= this.multiLevelFilters.length - 1) {
      return;
    }

    // 查找选中的节点
    const selectedNode = this.findNodeById(this.bookAttrs.syllabus, selectedValue);
    if (selectedNode && selectedNode.children && selectedNode.children.length > 0) {
      // 如果选中的节点有子节点，更新下一级的名称
      const nextLevel = level + 1;
      if (nextLevel < this.multiLevelFilters.length) {
        // 尝试从子节点的第一个元素获取层级名称
        const firstChild = selectedNode.children[0];
        if (firstChild && firstChild.level_name) {
          this.multiLevelFilters[nextLevel].name = firstChild.level_name;
          this.multiLevelFilters[nextLevel].placeholder = firstChild.level_name;
        }
      }
    }
  }

  /**
   * 根据ID查找节点
   * @param nodes 节点数组
   * @param id 要查找的ID
   * @returns 找到的节点或null
   */
  findNodeById(nodes: any[], id: number): any {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }
      if (node.children) {
        const result = this.findNodeById(node.children, id);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }


  changeSubTheme(theme_group_id: number, theme_id: number) {
    console.log('changeSubTheme', theme_group_id, theme_id);
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    console.log('onQueryParamsChange', params);
    if (this.ignoreNextTableQueryParams) {
      this.ignoreNextTableQueryParams = false;
      if (params.pageIndex === this.filter.pageIndex && params.pageSize === this.filter.pageSize) {
        return;
      }
    }

    const { pageSize, pageIndex, sort, filter } = params;
    // const currentSort = sort.find(item => item.value !== null);
    // const sortField = (currentSort && currentSort.key) || null;
    // const sortOrder = (currentSort && currentSort.value) || null;

    // 只更新分页和排序参数，保留多级筛选参数
    this.filter = {
      ...this.filter,
      pageSize: params.pageSize,
      pageIndex: params.pageIndex,
      sort: params.sort,
      filter: params.filter
    };

    if (this.activeView === 'drive' && !this.itemSelection) {
      this.saveListState();
      this.loadDriveData();
      return;
    }
    this.saveListState();
    this.loadData(this.filter);
  }
  ngOnInit() {
    if (!this.resourceType) {
      const routeSegments = this.activatedRoute.pathFromRoot[2]?.snapshot?.url;
      this.resourceType = routeSegments?.[2]?.path ?? '';
    }
    console.log('this.resourceType', this.resourceType);
    this.mainService = this.coursewareService;
    if (this.resourceType === 'video' || this.resourceType === 'audio') {
      this.mainService = this.mediaService;
      this.filter.pageSize = 10;
    } else if (this.resourceType === 'exercise') {
      this.mainService = this.exerciseService;
      this.filter.pageSize = 15;
    }
    this.initializeListState();
    if (!this.restoredFromPayload) {
      this.readInitialViewFromUrl();
    }
    this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe((params) => {
      this.onDriveQueryParamsChange(params);
    });
    this.isLoadingAttr = true;
    this.refreshCategory().then((bookAttrs: any) => {
      if (this.destroyed) {
        return;
      }
      this.applyBookAttrs(bookAttrs);
      if (!this.restoredFromPayload) {
        this.applyDriveStateFromUrl(this.activatedRoute.snapshot.queryParamMap);
      }
      this.isLoadingAttr = false;
      if (this.activeView === 'drive') {
        this.loadDriveData();
      }
    }).catch((err: any) => {
      this.isLoadingAttr = false;
      if (this.activeView === 'drive') {
        this.driveSidebarError = '分类加载失败';
      } else {
        this.nzMessageService.error(err.message || 'System Error');
      }
    });
    if (this.activeView === 'list') {
      this.loadData(this.filter);
    }
  }
  doFilter($evt: any) {
    if (!$evt) {
      return;
    }
    this.ignoreNextTableQueryParams = false;
    console.log('doFilter', $evt, this.filter);

    // 只更新分页参数，保留多级筛选参数
    this.filter = {
      ...this.filter,
      pageIndex: 1
    };

    this.saveListState();
    this.loadData(this.filter);
  }
  clearSearch() {
    this.ignoreNextTableQueryParams = false;
    this.filter.name = '';
    this.saveListState();
    // this.loadData({pageIndex: 1});
  }

  saveListState(): void {
    if (!this.shouldPersistListState()) {
      return;
    }
    const payload: ResourceListStatePayload = {
      resourceType: this.resourceType,
      view: this.activeView,
      filter: {
        ...this.filter,
        themes: { ...(this.filter.themes || {}) },
        level_filters: { ...(this.filter.level_filters || {}) }
      },
      levelSelectValues: [...(this.levelSelectValues || [])],
      driveNavPathIds: [...this.driveNav.pathIds],
      driveThemes: { ...(this.driveThemes || {}) },
    };

    try {
      sessionStorage.setItem(this.getListStateStorageKey(), JSON.stringify(payload));
    } catch (err) {
      console.warn('[resource list] save state failed', err);
    }
  }

  private initializeListState(): void {
    if (!this.shouldPersistListState()) {
      return;
    }

    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart && this.isLeavingToResourceChildPage(event.url)) {
        this.saveListState();
        this.markShouldRestoreListState();
      }
    });

    if (this.shouldRestoreListState()) {
      const payload = this.restoreListState();
      if (payload && payload.resourceType === this.resourceType) {
        this.applyResourceListPayload(payload);
        this.ignoreNextTableQueryParams = true;
      }
      this.clearShouldRestoreListState();
    }
  }

  ngOnDestroy() {
    this.destroyed = true;
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
      this.routerEventsSubscription = null;
    }
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
      this.queryParamsSubscription = null;
    }
  }

  private restoreListState(): ResourceListStatePayload | null {
    try {
      const raw = sessionStorage.getItem(this.getListStateStorageKey());
      return raw ? JSON.parse(raw) as ResourceListStatePayload : null;
    } catch (err) {
      console.warn('[resource list] restore state failed', err);
      sessionStorage.removeItem(this.getListStateStorageKey());
      return null;
    }
  }

  private getListStateStorageKey(): string {
    return `${this.listStatePrefix}:${this.resourceType}`;
  }

  private getListRestoreStorageKey(): string {
    return `${this.listRestorePrefix}:${this.resourceType}`;
  }

  private markShouldRestoreListState(): void {
    try {
      sessionStorage.setItem(this.getListRestoreStorageKey(), String(Date.now()));
    } catch (err) {
      console.warn('[resource list] mark restore failed', err);
    }
  }

  private clearShouldRestoreListState(): void {
    sessionStorage.removeItem(this.getListRestoreStorageKey());
  }

  private shouldRestoreListState(): boolean {
    const raw = sessionStorage.getItem(this.getListRestoreStorageKey());
    const savedAt = raw ? parseInt(raw, 10) : 0;
    if (!savedAt || Date.now() - savedAt > this.listRestoreMaxAgeMs) {
      this.clearShouldRestoreListState();
      return false;
    }
    return true;
  }

  private isLeavingToResourceChildPage(url: string): boolean {
    const resourceRoot = `/admin/v3/resource/${this.resourceType}`;
    if (!url.startsWith(`${resourceRoot}/`)) {
      return false;
    }
    return !url.startsWith(`${resourceRoot}/list`) && !url.startsWith(`${resourceRoot}/category`);
  }

  private applyResourceListPayload(payload: ResourceListStatePayload): void {
    this.restoredFromPayload = true;
    this.activeView = payload.view ?? 'drive';
    this.driveNav.pathIds = [...(payload.driveNavPathIds ?? [])];
    this.driveThemes = { ...(payload.driveThemes || {}) };
    this.filter = {
      ...this.filter,
      ...(payload.filter || {}),
      themes: { ...(payload.filter?.themes || {}) },
      level_filters: { ...(payload.filter?.level_filters || {}) }
    };
    this.levelSelectValues = [...(payload.levelSelectValues || [])];
    this.syncDriveQueryParams(true);
  }

  private syncDriveQueryParams(replaceUrl = true): void {
    const isDrive = this.activeView === 'drive';
    const searchName = this.filter.name?.trim() || '';
    const path = isDrive && this.driveNav.pathIds.length
      ? this.driveNav.pathIds.join('/')
      : null;
    this.router.navigate([], {
      queryParams: {
        view: isDrive ? null : 'list',
        path,
        name: isDrive && searchName ? searchName : null,
        scope: null,
      },
      queryParamsHandling: 'merge',
      replaceUrl,
    });
  }

  private applyDriveSearchFromUrl(params: { get: (key: string) => string | null }): boolean {
    const nameParam = params.get('name')?.trim() ?? '';
    if (nameParam) {
      const changed = this.filter.name !== nameParam;
      this.filter.name = nameParam;
      return changed;
    }
    if (this.filter.name) {
      this.filter.name = '';
      return true;
    }
    return false;
  }

  private applyDriveStateFromUrl(params: { get: (key: string) => string | null }): void {
    this.applyDrivePathFromUrl(params.get('path'));
    this.applyDriveSearchFromUrl(params);
  }

  private applyDrivePathFromUrl(pathParam: string | null): void {
    const parsed = parseDrivePathParam(pathParam);
    const valid = validatePathIdsInSyllabus(this.bookAttrs?.syllabus ?? [], parsed);
    this.driveNav.pathIds = valid;
    if (parsed.length > 0 && valid.length !== parsed.length) {
      this.syncDriveQueryParams(true);
    }
    this.syncDriveSidebarExpandedFromPath();
  }

  private isSamePathIds(a: number[], b: number[]): boolean {
    return a.length === b.length && a.every((id, index) => id === b[index]);
  }

  private onDriveQueryParamsChange(params: { get: (key: string) => string | null }): void {
    if (this.destroyed || !this.bookAttrs?.syllabus) {
      return;
    }
    const viewParam = params.get('view');
    const nextView: 'list' | 'drive' = viewParam === 'list' ? 'list' : 'drive';
    if (nextView !== this.activeView) {
      this.activeView = nextView;
      if (nextView === 'list') {
        this.loadData(this.filter);
        return;
      }
      this.loadDriveData();
    }
    if (nextView !== 'drive') {
      return;
    }
    const parsed = parseDrivePathParam(params.get('path'));
    const valid = validatePathIdsInSyllabus(this.bookAttrs.syllabus, parsed);
    const pathChanged = !this.isSamePathIds(valid, this.driveNav.pathIds);
    if (pathChanged) {
      this.driveNav.pathIds = valid;
      this.filter.pageIndex = 1;
      this.syncDriveSidebarExpandedFromPath();
    }
    const searchChanged = this.applyDriveSearchFromUrl(params);
    if (pathChanged || searchChanged) {
      this.loadDriveData();
    }
  }

  private shouldPersistListState(): boolean {
    return !this.itemSelection;
  }

  /**
   * 处理筛选参数，将多级筛选的参数转换为后端需要的格式
   * @param query 原始查询参数
   * @returns 处理后的查询参数
   */
  processFilterParams(query: any): any {
    query = {
      ...(query || {}),
      themes: { ...(query?.themes || {}) },
      level_filters: { ...(query?.level_filters || {}) }
    };
    if (query.path) {
      const p = query.path.split('/');
      query.course_id = p[p.length - 1];
      query.syllabus_id = p[0];
    }
    return query;

    const processedQuery = { ...query };

    // 处理多级筛选参数
    if (query.level_filters) {
      // 收集所有有效的level_X参数，按层级顺序排序
      const levelValues: string[] = [];

      // 从level_2开始，按顺序收集有效的值
      for (let i = 2; i < 10; i++) { // 支持最多10级
        const levelKey = `level_${i}`;
        const value = query.level_filters[levelKey];
        if (value !== '' && value !== null && value !== undefined) {
          levelValues.push(value.toString());
        } else {
          // 如果某个层级没有值，停止收集后续层级
          break;
        }
      }

      // 构建完整路径：分类/大纲/三级/四级...
      const pathParts: string[] = [];

      // 添加分类（第一级）
      if (query.syllabus_id) {
        pathParts.push(query.syllabus_id.toString());
      }

      // 添加大纲（第二级）
      if (query.course_id) {
        pathParts.push(query.course_id.toString());
      }

      // 添加第三级及以后的筛选值
      pathParts.push(...levelValues);

      // 如果有多级筛选值，设置path参数
      if (levelValues.length > 0) {
        processedQuery.path = pathParts.join('/');
        console.log('完整筛选路径:', processedQuery.path);
      } else {
        // 如果没有第三级及以后的筛选，传空
        processedQuery.path = '';
      }

      // 删除level_filters对象，避免重复传递
      delete processedQuery.level_filters;
    }

    return processedQuery;
  }

  /**
   * 解析path参数，恢复各个层级的筛选值
   * @param path 路径字符串，如 "/1/2/123/456/"
   * @returns 解析后的筛选对象，包含syllabus_id, course_id和level_filters
   */
  parseLevelPath(path: string): any {
    if (!path || path === '') {
      return {};
    }

    // 移除开头和结尾的斜杠，然后分割
    const cleanPath = path.replace(/^\/+|\/+$/g, '');
    const pathValues = cleanPath.split('/');

    const result: any = {};

    // 解析各个层级
    if (pathValues.length >= 1) {
      // tslint:disable-next-line:radix
      result.syllabus_id = parseInt(pathValues[0]);
    }

    if (pathValues.length >= 2) {
      // tslint:disable-next-line:radix
      result.course_id = parseInt(pathValues[1]);
    }

    // 解析第三级及以后的筛选值
    if (pathValues.length > 2) {
      result.level_filters = {};
      for (let i = 2; i < pathValues.length; i++) {
        const levelKey = `level_${i}`;
        const value = parseInt(pathValues[i]);
        if (!isNaN(value)) {
          result.level_filters[levelKey] = value;
        }
      }
    }

    return result;
  }

  /**
   * 获取当前的完整筛选路径
   * @returns 当前的完整筛选路径字符串
   */
  getCurrentLevelPath(): string {
    const pathParts: string[] = [];

    // 添加分类（第一级）
    if (this.filter.syllabus_id) {
      pathParts.push(this.filter.syllabus_id.toString());
    }

    // 添加大纲（第二级）
    if (this.filter.course_id) {
      pathParts.push(this.filter.course_id.toString());
    }

    // 添加第三级及以后的筛选值
    if (this.filter.level_filters) {
      for (let i = 2; i < 10; i++) {
        const levelKey = `level_${i}`;
        const value = this.filter.level_filters[levelKey];
        if (value !== '' && value !== null && value !== undefined) {
          pathParts.push(value.toString());
        } else {
          break;
        }
      }
    }

    // 如果有第三级及以后的筛选值，返回完整路径
    if (pathParts.length >= 3) {
      return '/' + pathParts.join('/') + '/';
    }

    return '';
  }

  loadData(query?: any) {
    console.log('loadData query', query);
    this.isLoading = true;

    // 处理筛选参数
    const processedQuery = this.processFilterParams(query || this.filter);

    // 显示当前的多级筛选路径
    const currentPath = this.getCurrentLevelPath();
    if (currentPath) {
      console.log('当前多级筛选路径:', currentPath);
    }

    console.log('处理后的查询参数:', processedQuery);

    this.mainService.list(this.resourceType, processedQuery).then((result: any) => {
      console.log('loadData data', result);
      this.dataSet = result.rows.map((r: any) => {
        r.created_date = r.created_date.substring(0, 10);
        if (r.enabled !== undefined && r.enabled !== null && r.enabled !== '') {
          r.enabled = +r.enabled;
        } else if (r.reserve3 !== undefined && r.reserve3 !== null && r.reserve3 !== '') {
          r.enabled = +r.reserve3;
        }
        return r;
      });
      this.totalNum = result.total;
      this.isLoading = false;

    }).catch((err: any) => {
      this.nzMessageService.error(`錯誤：${err.message}`);
      this.isLoading = false;
    });

  }

  /**
   * 资源删除
   * @param id 资源id
   * @param resourceType 资源类型
   */
  deleteResource(id: number, resourceType: string) {
    this.mainService.delete(resourceType, id).then(() => {
      this.nzMessageService.success('删除成功');
      this.ignoreNextTableQueryParams = false;
      this.filter.pageIndex = 1;
      this.saveListState();
      this.reloadActiveViewData();
    }).catch((err: any) => {
      this.nzMessageService.error(err.message || 'System Error');
    });
  }

  /**
   * 资源复制
   * @param id 资源id
   * @param resourceType 资源类型
   */
  copyResource(id: number, resourceType: string) {
    console.log('copyResource', id, resourceType);
    this.mainService.copy(id, {}).then(() => {
      this.nzMessageService.success('复制成功');
      this.ignoreNextTableQueryParams = false;
      this.filter.pageIndex = 1;
      this.saveListState();
      this.reloadActiveViewData();
    }).catch((err: any) => {
      this.nzMessageService.error(err.message || 'System Error');
    });
  }

  /**
   * 将正序的seq转换为倒序显示
   * 数据库范围：-500到500，正序排列
   * 显示范围：1000到0，倒序显示
   * @param seq 原始seq值（-500到500）
   * @returns 转换后的倒序值（1000到0）
   */
  getReversedSeq(seq: number): number {
    if (seq === null || seq === undefined) {
      return seq;
    }

    // 数据库范围：-500到500，总共1001个数
    const minSeq = -5000;
    const maxSeq = 5000;
    const totalRange = maxSeq - minSeq + 1; // 1001

    // 显示范围：1000到0，总共1001个数
    const displayMax = 10000;
    const displayMin = 0;

    // 将seq从[-500, 500]映射到[0, 1000]
    // 首先将seq从[-500, 500]映射到[0, 1000]
    const normalizedSeq = seq - minSeq; // 现在范围是[0, 1000]

    // 然后进行倒序转换：0->1000, 1->999, 2->998, ..., 1000->0
    const reversedSeq = displayMax - normalizedSeq;

    return reversedSeq;
  }

  /**
   * 将倒序显示值转换回原始数据库seq值
   * 显示范围：1000到0，倒序显示
   * 数据库范围：-500到500，正序排列
   * @param displayValue 显示值（1000到0）
   * @returns 原始数据库seq值（-500到500）
   */
  getOriginalSeq(displayValue: number): number {
    if (displayValue === null || displayValue === undefined) {
      return displayValue;
    }

    // 数据库范围：-500到500，总共1001个数
    const minSeq = -5000;
    const maxSeq = 5000;

    // 显示范围：1000到0，总共1001个数
    const displayMax = 10000;

    // 逆转换：1000->0, 999->1, 998->2, ..., 0->1000
    const normalizedSeq = displayMax - displayValue;

    // 将[0, 1000]映射回[-500, 500]
    const originalSeq = normalizedSeq + minSeq;

    return originalSeq;
  }

  /**
   * 点击排序字段，打开编辑弹框
   * @param row 当前行数据
   */
  openEditSeqModal(row: any): void {
    this.currentEditRow = row;
    // 保存点击时的原始排序号（显示值）
    this.originalSeqValue = this.getReversedSeq(row.seq);
    // 将当前显示的排序号作为编辑值
    this.editSeqValue = this.originalSeqValue;
    this.isEditSeqModalVisible = true;
  }

  /**
   * 确认修改排序号
   */
  confirmEditSeq(): void {
    if (this.currentEditRow && this.editSeqValue !== null && this.editSeqValue !== undefined) {
      // 将编辑值转换回数据库seq值
      const newSeq = this.getOriginalSeq(this.editSeqValue);

      this.isLoading = true;
      this.mainService.save(this.resourceType, {
        id: this.currentEditRow.id,
        seq: newSeq
      }).then(() => {
        this.nzMessageService.success('排序号修改成功');
        this.isEditSeqModalVisible = false;
        this.currentEditRow = null;
        this.editSeqValue = 0;
        this.originalSeqValue = 0;
        this.isLoading = false;
        // 重新加载数据
        this.loadData(this.filter);
      }).catch((err: any) => {
        this.nzMessageService.error(err.message || '修改失败');
        this.isLoading = false;
      });
    }
  }

  /**
   * 取消编辑排序号
   */
  cancelEditSeq(): void {
    this.isEditSeqModalVisible = false;
    this.currentEditRow = null;
    this.editSeqValue = 0;
    this.originalSeqValue = 0;
  }

  selectThisItem(row: any) {
    // console.log('selectThisItem', row);
    this.itemSelection = new Map([[0, row]]);
    this.itemSelectionChange.emit(this.itemSelection);
  }

  onDriveSidebarExpandedKeysChange(keys: string[]): void {
    this.driveSidebarExpandedKeys = keys;
  }

  private syncDriveSidebarExpandedFromPath(): void {
    const pathIds = this.driveNav.pathIds;
    const required = pathIds.length
      ? pathIds.slice(0, -1).map(String)
      : (this.bookAttrs?.syllabus ?? []).map((n: SyllabusTreeNode) => String(n.id));
    this.driveSidebarExpandedKeys = Array.from(new Set([
      ...this.driveSidebarExpandedKeys,
      ...required,
    ]));
  }

  get driveSelectedKeys(): string[] {
    const pathIds = this.driveNav.pathIds;
    return pathIds.length ? [String(pathIds[pathIds.length - 1])] : [];
  }

  get currentDriveFolderId(): number | null {
    const pathIds = this.driveNav.pathIds;
    return pathIds.length ? pathIds[pathIds.length - 1] : null;
  }

  get isDriveSearch(): boolean {
    return !!this.filter.name?.trim();
  }

  get canCreateDriveFolder(): boolean {
    return !this.isDriveSearch;
  }

  get driveSortableFileCards(): DriveFileCard[] {
    if (!this.currentDriveFolderId || this.isDriveSearch || hasActiveThemes(this.driveThemes)) {
      return [];
    }
    return this.driveFileCards;
  }

  get driveOtherFileCards(): DriveFileCard[] {
    return [];
  }

  get canSortDriveFiles(): boolean {
    if (!this.currentDriveFolderId) {
      return false;
    }
    if (this.filter.name?.trim()) {
      return false;
    }
    if (hasActiveThemes(this.driveThemes)) {
      return false;
    }
    if (this.driveSortableFileCards.length === 0) {
      return false;
    }
    return true;
  }

  get hasDriveClipboard(): boolean {
    return (this.driveClipboard?.items.length ?? 0) > 0;
  }

  get canDrivePaste(): boolean {
    if (!this.hasDriveClipboard || this.isDriveSearch || this.drivePasteLoading) {
      return false;
    }
    const clipboard = this.driveClipboard;
    if (!clipboard?.items.length) {
      return false;
    }
    const targetFolderId = this.resolveDrivePasteTargetFolderId();
    if (targetFolderId == null) {
      return false;
    }
    if (clipboard.mode === 'copy') {
      const hasFile = clipboard.items.some((item) => item.type === 'file');
      if (hasFile && !this.currentDriveFolderId) {
        return false;
      }
      if (hasFile && this.resourceType !== 'book' && this.resourceType !== 'cartoon') {
        return false;
      }
    }
    return !this.isDrivePasteTargetInvalid(targetFolderId);
  }

  get driveMoveTargetLabel(): string {
    const items = this.driveMoveTarget?.items ?? [];
    if (!items.length) {
      return '';
    }
    if (items.length === 1) {
      return items[0].name;
    }
    return `${items.length} 项`;
  }

  get driveMoveModalTitle(): string {
    const items = this.driveMoveTarget?.items ?? [];
    if (!items.length) {
      return '移动';
    }
    const hasFolder = items.some((item) => item.type === 'folder');
    const hasFile = items.some((item) => item.type === 'file');
    if (hasFolder && hasFile) {
      return '移动选中项';
    }
    return hasFolder ? '移动文件夹' : '移动文件';
  }

  get driveRootThemes(): any[] {
    const syllabusId = this.driveNav.pathIds[0];
    if (!syllabusId) {
      return [];
    }
    return (this.bookAttrs?.themes || []).filter((theme: any) => theme.syllabus_id === syllabusId);
  }

  get driveSubThemes(): any[] {
    const courseId = this.driveNav.pathIds[1];
    if (!courseId) {
      return [];
    }
    return (this.bookAttrs?.themes || []).filter((theme: any) => theme.syllabus_id === courseId);
  }

  get hasActiveDriveThemes(): boolean {
    return hasActiveThemes(this.driveThemes);
  }

  get showDriveThemesFilter(): boolean {
    return this.resourceType !== 'audio'
      && this.resourceType !== 'video'
      && this.driveNav.pathIds.length >= 1;
  }

  onViewTabChange(index: number): void {
    const view: 'list' | 'drive' = index === 0 ? 'list' : 'drive';
    if (view === this.activeView) {
      return;
    }
    this.activeView = view;
    this.syncDriveQueryParams(true);
    if (view === 'drive') {
      this.isLoadingAttr = true;
      this.refreshCategory()
        .then((data) => {
          if (this.destroyed) {
            return;
          }
          this.applyBookAttrs(data);
          this.isLoadingAttr = false;
          this.loadDriveData();
        })
        .catch(() => {
          this.isLoadingAttr = false;
          this.driveSidebarError = '分类加载失败';
        });
      return;
    }
    this.loadData(this.filter);
  }

  onDriveFilter(): void {
    this.filter.pageIndex = 1;
    this.saveListState();
    this.syncDriveQueryParams(false);
    this.loadDriveData();
  }

  clearDriveSearch(): void {
    this.filter.name = '';
    this.filter.pageIndex = 1;
    this.saveListState();
    this.syncDriveQueryParams(false);
    this.loadDriveData();
  }

  navigateToFolder(pathIds: number[]): void {
    this.filter.name = '';
    this.driveNav.pathIds = [...pathIds];
    this.filter.pageIndex = 1;
    this.driveSelectionResetToken += 1;
    this.syncDriveSidebarExpandedFromPath();
    this.syncDriveQueryParams(false);
    this.saveListState();
    this.loadDriveData();
  }

  onDriveFolderSelect(event: { pathIds: number[] }): void {
    this.navigateToFolder(event.pathIds);
  }

  onDriveFolderOpen(pathIds: number[]): void {
    this.navigateToFolder(pathIds);
  }

  onDriveBreadcrumbNavigate(index: number): void {
    if (index < 0) {
      this.navigateToFolder([]);
      return;
    }
    this.navigateToFolder(this.driveNav.pathIds.slice(0, index + 1));
  }

  onDriveFileAction(event: DriveFileActionEvent): void {
    if (event.action === 'locateFolder') {
      const file = this.driveFileCards.find((item) => item.id === event.fileId);
      const folderRef = resolveDriveFolderRef(file?.folders, event.folderId);
      if (!folderRef?.folderId) {
        this.nzMessageService.warning('无法定位所在文件夹');
        return;
      }
      const pathIds = buildPathIdsFromFolder(
        folderRef.folderId,
        folderRef.folderPath,
        this.syllabusIdToNode,
      );
      if (!pathIds.length) {
        this.nzMessageService.warning('无法定位所在文件夹');
        return;
      }
      this.filter.name = '';
      this.filter.pageIndex = 1;
      this.saveListState();
      this.navigateToFolder(pathIds);
      return;
    }
    if (event.action === 'rename') {
      const file = this.driveFileCards.find((item) => item.id === event.fileId);
      if (file) {
        this.openDriveRenameModal('file', file.id, file.name);
      }
      return;
    }
    if (event.action === 'move') {
      const file = this.driveFileCards.find((item) => item.id === event.fileId);
      if (file) {
        const fromFolderId = this.currentDriveFolderId
          ?? resolveDriveFolderId(file.folders)
          ?? null;
        this.openDriveMoveModal([{
          type: 'file',
          id: file.id,
          name: file.name,
          fromFolderId,
        }]);
      }
      return;
    }
    if (event.action === 'toggleEnabled') {
      this.toggleDriveFileEnabled(event.fileId);
      return;
    }
    if (event.action === 'copy') {
      this.copyResource(event.fileId, this.resourceType);
      return;
    }
    if (event.action === 'removeFromFolder') {
      const file = this.driveFileCards.find((item) => item.id === event.fileId);
      const folderId = event.folderId ?? this.currentDriveFolderId
        ?? resolveDriveFolderId(file?.folders)
        ?? null;
      if (!file || !folderId) {
        this.nzMessageService.warning('无法确定要移除的文件夹');
        return;
      }
      const folderName = file.folders?.find((item) => item.folderId === folderId)?.folderName
        ?? this.resolveFolderName(folderId)
        ?? String(folderId);
      this.modalService.confirm({
        nzTitle: `确定将「${file.name}」从文件夹「${folderName}」中移除？`,
        nzContent: '仅解除文件夹关联，不会删除文件本身。',
        nzOnOk: () => this.tagsService.removeFromFolder(this.resourceType, {
          item_id: file.id,
          syllabus_id: folderId,
        }).then(() => {
          this.nzMessageService.success('已从文件夹移除');
          this.loadDriveData();
        }).catch((err: any) => {
          this.nzMessageService.error(err?.message || '从文件夹移除失败');
        }),
      });
      return;
    }
    if (event.action === 'delete') {
      this.modalService.confirm({
        nzTitle: '资源删除后不可恢复，确定删除资源？',
        nzOnOk: () => this.deleteResource(event.fileId, this.resourceType),
      });
      return;
    }
    this.saveListState();
    const segments = ['/admin/v3/resource', this.resourceType, 'edit', String(event.fileId)];
    if (event.action === 'view' && (this.resourceType === 'book' || this.resourceType === 'cartoon')) {
      segments.push('reading');
    }
    this.router.navigate(segments, { queryParams: { tabIndex: '0' } });
  }

  onDriveFolderAction(event: DriveFolderActionEvent): void {
    const action = event.action === 'rename' ? 'edit' : event.action;
    if (action === 'edit') {
      const folder = this.driveFolderCards.find((item) => item.id === event.folderId);
      if (folder) {
        this.openDriveFolderEditModal(folder);
      }
      return;
    }
    if (event.action === 'move') {
      const folder = this.driveFolderCards.find((item) => item.id === event.folderId);
      if (folder) {
        this.openDriveMoveModal([{
          type: 'folder',
          id: folder.id,
          name: folder.name,
          folder,
        }]);
      }
      return;
    }
    if (event.action === 'toggleEnabled') {
      this.toggleDriveFolderEnabled(event.folderId);
    }
  }

  onDriveSelectionToolbarAction(event: DriveSelectionToolbarEvent): void {
    if (event.action === 'clear') {
      return;
    }
    if (event.action === 'copy') {
      this.setDriveClipboard('copy', event.items);
      this.nzMessageService.success(`已复制 ${event.items.length} 项`);
      return;
    }
    if (event.action === 'cut') {
      this.setDriveClipboard('cut', event.items);
      this.nzMessageService.success(`已剪切 ${event.items.length} 项`);
      return;
    }
    if (event.action === 'paste') {
      this.pasteDriveClipboard();
      return;
    }
    if (event.action === 'move') {
      this.openDriveMoveModal(this.buildDriveMoveItems(event.items));
    }
  }

  onDriveFolderSort(event: CdkDragDrop<DriveFolderCard[]>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }
    const previousCards = [...this.driveFolderCards];
    moveItemInArray(this.driveFolderCards, event.previousIndex, event.currentIndex);
    const seqData = this.driveFolderCards.map((item, index) => [item.id, index]);
    this.syllabusService.seq(this.resourceType, seqData).then(() => {
      this.nzMessageService.success('排序更新成功');
      return this.refreshCategory();
    }).then((bookAttrs) => {
      if (this.destroyed) {
        return;
      }
      this.applyBookAttrs(bookAttrs);
      this.loadDriveData();
    }).catch((err: any) => {
      this.driveFolderCards = previousCards;
      this.nzMessageService.error(err?.message || '排序更新失败');
    });
  }

  onDriveFileSort(event: CdkDragDrop<DriveFileCard[]>): void {
    const folderId = this.currentDriveFolderId;
    if (!folderId || event.previousIndex === event.currentIndex) {
      return;
    }
    const previousCards = [...this.driveFileCards];
    const sortable = [...this.driveSortableFileCards];
    moveItemInArray(sortable, event.previousIndex, event.currentIndex);
    const others = this.driveOtherFileCards;
    this.driveFileCards = [...sortable, ...others];
    const offset = (this.filter.pageIndex - 1) * this.filter.pageSize;
    const seqData = sortable.map((item, index) => [item.id, offset + index] as [number, number]);
    this.tagsService.updateItemSeq(this.resourceType, { syllabus_id: folderId, seq: seqData }).then(() => {
      this.nzMessageService.success('排序更新成功');
      this.loadDriveData();
    }).catch((err: any) => {
      this.driveFileCards = previousCards;
      this.nzMessageService.error(err?.message || '排序更新失败');
    });
  }

  openDriveCreateFolderModal(): void {
    this.driveCreateFolderValue = '';
    this.driveCreateFolderNameDuplicated = false;
    this.isDriveCreateFolderModalVisible = true;
  }

  cancelDriveCreateFolder(): void {
    this.isDriveCreateFolderModalVisible = false;
    this.driveCreateFolderValue = '';
    this.driveCreateFolderNameDuplicated = false;
    this.driveCreateFolderLoading = false;
  }

  confirmDriveCreateFolder(): void {
    const name = this.driveCreateFolderValue?.trim();
    if (!name) {
      this.nzMessageService.warning('请输入文件夹名称');
      return;
    }
    const payload = this.buildDriveNewFolderPayload(name);
    this.driveCreateFolderLoading = true;
    this.syllabusService.checkNameExist(this.resourceType, {
      id: 0,
      pid: payload['pid'],
      syllabus_id: payload['syllabus_id'],
      name,
    }).then((resp: any) => {
      if (resp?.id) {
        this.driveCreateFolderNameDuplicated = true;
        this.driveCreateFolderLoading = false;
        return Promise.reject(new Error('名称不可重复'));
      }
      return this.syllabusService.save(this.resourceType, payload);
    }).then(() => {
      this.nzMessageService.success('文件夹创建成功');
      this.cancelDriveCreateFolder();
      return this.refreshCategory();
    }).then((data) => {
      if (this.destroyed) {
        return;
      }
      this.applyBookAttrs(data);
      this.loadDriveData();
    }).catch((err: any) => {
      this.driveCreateFolderLoading = false;
      if (err?.message !== '名称不可重复') {
        this.nzMessageService.error(err?.message || '创建失败');
      }
    });
  }

  openDriveRenameModal(type: 'file', id: number, name: string): void {
    this.driveRenameTarget = { type, id, name };
    this.driveRenameValue = name;
    this.driveRenameNameDuplicated = false;
    this.driveFolderEditCover = '';
    this.driveFolderEditCoverOriginal = '';
    this.isDriveRenameModalVisible = true;
  }

  openDriveFolderEditModal(folder: DriveFolderCard): void {
    const node = this.syllabusIdToNode.get(folder.id);
    const rawCover = folder.cover ?? node?.cover ?? '';
    this.driveRenameTarget = {
      type: 'folder',
      id: folder.id,
      name: folder.name,
      folder,
    };
    this.driveRenameValue = folder.name;
    this.driveRenameNameDuplicated = false;
    this.driveFolderEditCoverOriginal = rawCover;
    this.driveFolderEditCover = rawCover
      ? getResourceCoverUrl(rawCover, this.protocol, this.host, this.bucket)
      : '';
    this.isDriveRenameModalVisible = true;
  }

  onDriveFolderCoverUploaded(event: { url?: string }): void {
    this.driveFolderEditCover = event?.url || '';
  }

  openDriveMoveModal(
    items: Array<{
      type: 'file' | 'folder';
      id: number;
      name: string;
      folder?: DriveFolderCard;
      fromFolderId?: number | null;
    }>,
  ): void {
    if (!items.length) {
      return;
    }
    const prepareSeq = ++this.driveMovePrepareSeq;
    this.driveMoveTarget = { items };
    this.driveMoveTreeNodes = [];
    this.driveMoveSelectedFolderId = null;
    this.driveMoveSelectedFolderName = '';
    this.driveMoveExpandedKeys = [];
    this.driveMoveTreeLoading = true;
    this.isDriveMoveModalVisible = true;
    setTimeout(() => {
      if (prepareSeq !== this.driveMovePrepareSeq || !this.isDriveMoveModalVisible) {
        return;
      }
      const disabledIds = new Set<number>();
      items.forEach((item) => {
        if (item.type === 'folder') {
          disabledIds.add(item.id);
          collectDescendantIds(item.id, this.bookAttrs?.syllabus ?? []).forEach((descendantId) => {
            disabledIds.add(descendantId);
          });
          return;
        }
        const sourceFolderId = item.fromFolderId ?? this.currentDriveFolderId ?? null;
        if (sourceFolderId) {
          disabledIds.add(sourceFolderId);
        }
      });
      this.driveMoveTreeNodes = buildMoveTargetTreeNodes(this.driveTreeNodes, disabledIds);
      this.driveMoveExpandedKeys = [...this.driveSidebarExpandedKeys];
      if (prepareSeq === this.driveMovePrepareSeq) {
        this.driveMoveTreeLoading = false;
      }
    }, 0);
  }

  cancelDriveMove(): void {
    this.driveMovePrepareSeq += 1;
    this.isDriveMoveModalVisible = false;
    this.driveMoveLoading = false;
    this.driveMoveTreeLoading = false;
    this.driveMoveTarget = null;
    this.driveMoveTreeNodes = [];
    this.driveMoveSelectedFolderId = null;
    this.driveMoveSelectedFolderName = '';
    this.driveMoveExpandedKeys = [];
  }

  onDriveMoveTreeClick(event: NzFormatEmitEvent): void {
    if (event.eventName !== 'click') {
      return;
    }
    const node = event.node;
    if (!node || node.isDisabled) {
      return;
    }
    this.driveMoveSelectedFolderId = +node.key;
    this.driveMoveSelectedFolderName = node.title ?? '';
  }

  onDriveMoveExpandChange(event: NzFormatEmitEvent): void {
    const key = event.node?.key;
    if (!key) {
      return;
    }
    const next = new Set(this.driveMoveExpandedKeys);
    if (event.node?.isExpanded) {
      next.add(key);
    } else {
      next.delete(key);
    }
    this.driveMoveExpandedKeys = Array.from(next);
  }

  confirmDriveMove(): void {
    const target = this.driveMoveTarget;
    const targetFolderId = this.driveMoveSelectedFolderId;
    if (this.driveMoveTreeLoading) {
      return;
    }
    if (!target?.items.length || !targetFolderId) {
      this.nzMessageService.warning('请选择目标文件夹');
      return;
    }
    this.driveMoveLoading = true;
    this.executeDriveMoveItems(target.items, targetFolderId).then(() => {
      this.nzMessageService.success('移动成功');
      this.cancelDriveMove();
      const hasFolder = target.items.some((item) => item.type === 'folder');
      if (hasFolder) {
        return this.refreshCategory().then((data) => {
          if (this.destroyed) {
            return;
          }
          this.applyBookAttrs(data);
          this.loadDriveData();
        });
      }
      this.loadDriveData();
      return undefined;
    }).catch((err: any) => {
      this.driveMoveLoading = false;
      this.nzMessageService.error(err?.message || '移动失败');
    });
  }

  private setDriveClipboard(mode: DriveClipboard['mode'], items: DriveSelectedItem[]): void {
    const clipboardItems = this.buildDriveClipboardItems(items);
    if (!clipboardItems.length) {
      return;
    }
    this.driveClipboard = { mode, items: clipboardItems };
  }

  private buildDriveClipboardItems(items: DriveSelectedItem[]): DriveClipboardItem[] {
    return items.map((item) => {
      if (item.type === 'folder') {
        const folder = this.driveFolderCards.find((entry) => entry.id === item.id);
        return {
          ...item,
          fromFolderId: folder?.pathIds.length
            ? folder.pathIds[folder.pathIds.length - 2] ?? 0
            : 0,
        };
      }
      const file = this.driveFileCards.find((entry) => entry.id === item.id);
      const fromFolderId = this.currentDriveFolderId
        ?? resolveDriveFolderId(file?.folders)
        ?? null;
      return {
        ...item,
        fromFolderId,
      };
    });
  }

  private buildDriveMoveItems(items: DriveSelectedItem[]): Array<{
    type: 'file' | 'folder';
    id: number;
    name: string;
    folder?: DriveFolderCard;
    fromFolderId?: number | null;
  }> {
    return items.map((item) => {
      if (item.type === 'folder') {
        const folder = this.driveFolderCards.find((entry) => entry.id === item.id);
        return {
          type: 'folder',
          id: item.id,
          name: item.name,
          folder,
        };
      }
      const file = this.driveFileCards.find((entry) => entry.id === item.id);
      const fromFolderId = this.currentDriveFolderId
        ?? resolveDriveFolderId(file?.folders)
        ?? null;
      return {
        type: 'file',
        id: item.id,
        name: item.name,
        fromFolderId,
      };
    });
  }

  private pasteDriveClipboard(): void {
    const clipboard = this.driveClipboard;
    const targetFolderId = this.resolveDrivePasteTargetFolderId();
    if (!clipboard?.items.length) {
      this.nzMessageService.warning('剪贴板为空');
      return;
    }
    if (targetFolderId == null) {
      this.nzMessageService.warning('请先进入目标文件夹后再粘贴');
      return;
    }
    if (this.isDrivePasteTargetInvalid(targetFolderId)) {
      this.nzMessageService.warning('无法粘贴到当前位置');
      return;
    }
    this.drivePasteLoading = true;
    const pastePromise = clipboard.mode === 'cut'
      ? this.executeDriveMoveItems(clipboard.items, targetFolderId)
      : this.executeDriveCopyItems(clipboard.items, targetFolderId);
    pastePromise.then(() => {
      this.nzMessageService.success('粘贴成功');
      if (clipboard.mode === 'cut') {
        this.driveClipboard = null;
      }
      const hasFolder = clipboard.items.some((item) => item.type === 'folder');
      if (hasFolder) {
        return this.refreshCategory().then((data) => {
          if (this.destroyed) {
            return;
          }
          this.applyBookAttrs(data);
          this.loadDriveData();
        });
      }
      this.loadDriveData();
      return undefined;
    }).catch((err: any) => {
      this.nzMessageService.error(err?.message || '粘贴失败');
    }).finally(() => {
      this.drivePasteLoading = false;
    });
  }

  private executeDriveMoveItems(
    items: Array<{
      type: 'file' | 'folder';
      id: number;
      fromFolderId?: number | null;
    }>,
    targetFolderId: number,
  ): Promise<void> {
    let chain = Promise.resolve();
    items.forEach((item) => {
      chain = chain.then(() => {
        if (item.type === 'folder') {
          return this.syllabusService.moveFolder(this.resourceType, {
            id: item.id,
            pid: targetFolderId,
          }).then(() => undefined);
        }
        return this.tagsService.moveItem(this.resourceType, {
          item_id: item.id,
          to_syllabus_id: targetFolderId,
          from_syllabus_id: item.fromFolderId ?? undefined,
        }).then(() => undefined);
      });
    });
    return chain;
  }

  private executeDriveCopyItems(items: DriveClipboardItem[], _targetFolderId: number): Promise<void> {
    const fileItems = items.filter((item) => item.type === 'file');
    if (!fileItems.length) {
      return Promise.reject(new Error('当前仅支持复制文件'));
    }
    if (this.resourceType !== 'book' && this.resourceType !== 'cartoon') {
      return Promise.reject(new Error('当前资源类型不支持复制'));
    }
    let chain = Promise.resolve();
    fileItems.forEach((item) => {
      chain = chain.then(() => this.mainService.copy(item.id, {}).then(() => undefined));
    });
    return chain;
  }

  private resolveDrivePasteTargetFolderId(): number | null {
    if (this.currentDriveFolderId) {
      return this.currentDriveFolderId;
    }
    const clipboard = this.driveClipboard;
    const hasOnlyFolders = clipboard?.items.every((item) => item.type === 'folder') ?? false;
    if (this.driveNav.pathIds.length === 0 && clipboard?.mode === 'cut' && hasOnlyFolders) {
      return 0;
    }
    return null;
  }

  private isDrivePasteTargetInvalid(targetFolderId: number): boolean {
    const clipboard = this.driveClipboard;
    if (!clipboard?.items.length) {
      return true;
    }
    if (clipboard.mode !== 'cut') {
      return false;
    }
    return clipboard.items.some((item) => {
      if (item.type === 'file') {
        return item.fromFolderId === targetFolderId;
      }
      if (item.id === targetFolderId) {
        return true;
      }
      const descendants = collectDescendantIds(item.id, this.bookAttrs?.syllabus ?? []);
      return descendants.includes(targetFolderId);
    });
  }

  cancelDriveRename(): void {
    this.isDriveRenameModalVisible = false;
    this.driveRenameTarget = null;
    this.driveRenameValue = '';
    this.driveRenameNameDuplicated = false;
    this.driveRenameLoading = false;
    this.driveFolderEditCover = '';
    this.driveFolderEditCoverOriginal = '';
  }

  confirmDriveRename(): void {
    const target = this.driveRenameTarget;
    const newName = this.driveRenameValue?.trim();
    if (!target || !newName) {
      this.nzMessageService.warning('请输入名称');
      return;
    }
    if (target.type === 'file') {
      if (newName === target.name) {
        this.cancelDriveRename();
        return;
      }
      this.driveRenameLoading = true;
      this.saveDriveFileRename(target.id, newName).then(() => {
        this.nzMessageService.success('重命名成功');
        this.cancelDriveRename();
        this.loadDriveData();
      }).catch((err: any) => {
        this.driveRenameLoading = false;
        this.nzMessageService.error(err?.message || '重命名失败');
      });
      return;
    }
    const coverValue = this.driveFolderEditCover?.trim() || '';
    const originalCoverDisplay = this.driveFolderEditCoverOriginal
      ? getResourceCoverUrl(this.driveFolderEditCoverOriginal, this.protocol, this.host, this.bucket)
      : '';
    const coverChanged = coverValue !== originalCoverDisplay;
    if (newName === target.name && !coverChanged) {
      this.cancelDriveRename();
      return;
    }
    this.driveRenameLoading = true;
    this.saveDriveFolderEdit(target.folder!, newName, coverValue).then(() => {
      this.nzMessageService.success('保存成功');
      this.cancelDriveRename();
      return this.refreshCategory();
    }).then((data) => {
      if (this.destroyed) {
        return;
      }
      this.applyBookAttrs(data);
      this.loadDriveData();
    }).catch((err: any) => {
      this.driveRenameLoading = false;
      this.nzMessageService.error(err?.message || '保存失败');
    });
  }

  private saveDriveFileRename(fileId: number, name: string): Promise<void> {
    return this.mainService.save(this.resourceType, { id: fileId, name }).then(() => undefined);
  }

  private saveDriveFolderEdit(folder: DriveFolderCard, name: string, cover: string): Promise<void> {
    const overrides: Record<string, unknown> = { name };
    if (cover) {
      overrides['cover'] = cover;
    }
    const payload = this.buildDriveFolderSavePayload(folder, overrides);
    return this.syllabusService.checkNameExist(this.resourceType, {
      id: folder.id,
      pid: payload['pid'],
      syllabus_id: payload['syllabus_id'],
      name,
    }).then((resp: any) => {
      if (resp?.id) {
        this.driveRenameNameDuplicated = true;
        return Promise.reject(new Error('名称不可重复'));
      }
      return this.syllabusService.save(this.resourceType, payload).then(() => undefined);
    });
  }

  private buildDriveNewFolderPayload(name: string): Record<string, unknown> {
    const pathIds = this.driveNav.pathIds;
    const parentId = pathIds.length ? pathIds[pathIds.length - 1] : 0;
    const parentNode = parentId ? this.syllabusIdToNode.get(parentId) : null;
    const syllabusId = pathIds.length ? pathIds[0] : 0;
    const payload: Record<string, unknown> = {
      name,
      pid: parentId,
      seq: 0,
      enabled: 1,
    };
    if (syllabusId) {
      payload['syllabus_id'] = syllabusId;
    }
    if (!parentId) {
      payload['root'] = 1;
      payload['depth'] = 1;
    } else {
      payload['root'] = 0;
      payload['depth'] = (parentNode?.depth ?? pathIds.length) + 1;
    }
    return payload;
  }

  private buildDriveFolderSavePayload(
    folder: DriveFolderCard,
    overrides: Record<string, unknown> = {},
  ): Record<string, unknown> {
    const node = this.syllabusIdToNode.get(folder.id);
    const parentId = folder.pathIds.length >= 2
      ? folder.pathIds[folder.pathIds.length - 2]
      : 0;
    const pid = node?.pid ?? folder.pid ?? parentId;
    const syllabusId = node?.syllabus_id ?? folder.syllabus_id ?? folder.pathIds[0] ?? 0;
    const payload: Record<string, unknown> = {
      id: folder.id,
      name: folder.name,
      pid: pid || 0,
      syllabus_id: syllabusId,
      seq: node?.seq ?? 0,
      enabled: folder.enabled ?? node?.enabled ?? 1,
      cover: folder.cover ?? node?.cover ?? '',
      ...overrides,
    };
    if (!payload['cover']) {
      delete payload['cover'];
    }
    if (!payload['pid']) {
      payload['root'] = 1;
      payload['depth'] = 1;
    } else {
      payload['root'] = 0;
      payload['depth'] = node?.depth ?? 2;
    }
    return payload;
  }

  private toggleDriveFileEnabled(fileId: number): void {
    const file = this.driveFileCards.find((item) => item.id === fileId);
    if (!file || file.enabled === -1) {
      return;
    }
    const nextEnabled = file.enabled === 1 ? 0 : 1;
    this.mainService.save(this.resourceType, {
      id: fileId,
      reserve3: nextEnabled,
      enabled: nextEnabled,
    }).then(() => {
      this.nzMessageService.success(nextEnabled === 1 ? '已启用' : '已禁用');
      this.loadDriveData();
    }).catch((err: any) => {
      this.nzMessageService.error(err?.message || '状态更新失败');
    });
  }

  private toggleDriveFolderEnabled(folderId: number): void {
    const folder = this.driveFolderCards.find((item) => item.id === folderId);
    if (!folder) {
      return;
    }
    const nextEnabled = (folder.enabled ?? 1) === 1 ? 0 : 1;
    const payload = this.buildDriveFolderSavePayload(folder, { enabled: nextEnabled });
    this.syllabusService.save(this.resourceType, payload).then(() => {
      this.nzMessageService.success(nextEnabled === 1 ? '已启用' : '已禁用');
      this.refreshCategory().then((data) => {
        if (this.destroyed) {
          return;
        }
        this.applyBookAttrs(data);
        this.loadDriveData();
      });
    }).catch((err: any) => {
      this.nzMessageService.error(err?.message || '状态更新失败');
    });
  }

  openDriveThemesDrawer(): void {
    this.driveThemesDrawerVisible = true;
  }

  applyDriveThemes(): void {
    this.driveThemesDrawerVisible = false;
    this.filter.pageIndex = 1;
    this.saveListState();
    this.loadDriveData();
  }

  clearDriveThemes(): void {
    this.driveThemes = {};
    this.applyDriveThemes();
  }

  onDriveFileOpen(fileId: number): void {
    this.saveListState();
    this.router.navigate(['/admin/v3/resource', this.resourceType, 'edit', fileId], {
      queryParams: { tabIndex: '0' },
    });
  }

  onDrivePageChange({ pageIndex, pageSize }: { pageIndex: number; pageSize: number }): void {
    this.filter.pageIndex = pageIndex;
    this.filter.pageSize = pageSize;
    this.saveListState();
    this.loadDriveData();
  }

  onRetryCategory(): void {
    if (this.destroyed) {
      return;
    }
    this.driveSidebarError = null;
    this.refreshCategory()
      .then((data) => {
        if (this.destroyed) {
          return;
        }
        this.applyBookAttrs(data);
        this.loadDriveData();
      })
      .catch(() => {
        this.driveSidebarError = '分类加载失败';
      });
  }

  onRetryFiles(): void {
    this.driveFilesLoadError = null;
    this.loadDriveData();
  }

  refreshCategory(): Promise<any> {
    if (this.categoryInflight) {
      return this.categoryInflight;
    }
    this.categoryInflight = this.syllabusService.category(this.resourceType)
      .finally(() => {
        this.categoryInflight = null;
      });
    return this.categoryInflight;
  }

  private readInitialViewFromUrl(): void {
    const viewParam = this.activatedRoute.snapshot.queryParamMap.get('view');
    if (viewParam === 'list') {
      this.activeView = 'list';
    }
  }

  private applyBookAttrs(bookAttrs: any): void {
    this.bookAttrs = bookAttrs ?? {};
    const themes = this.bookAttrs.themes ?? [];
    const syllabus = this.bookAttrs.syllabus ?? [];
    const _cateThemeKeyValueItems: any = {};
    themes.forEach((theme: any) => {
      _cateThemeKeyValueItems[theme.id] = theme;
    });
    this.themeKeyValueItems = _cateThemeKeyValueItems;
    const _syllabusKeyValueItems: any = {};
    syllabus.forEach((item: any) => {
      _syllabusKeyValueItems[item.id] = item;
    });
    this.syllabusKeyValueItems = _syllabusKeyValueItems;
    this.levelSelectOptions = syllabus;
    this.initializeMultiLevelFilters();
    this.rebuildSyllabusIdToNode(syllabus);
    this.driveTreeNodes = syllabusToNzTree(syllabus);
    this.syncDriveSidebarExpandedFromPath();
  }

  private rebuildSyllabusIdToNode(syllabus: SyllabusTreeNode[]): void {
    this.syllabusIdToNode = new Map<number, SyllabusTreeNode>();
    const walk = (nodes: SyllabusTreeNode[]) => {
      (nodes || []).forEach((node) => {
        this.syllabusIdToNode.set(node.id, node);
        if (node.children?.length) {
          walk(node.children);
        }
      });
    };
    walk(syllabus);
  }

  private buildFolderCards(pathIds: number[]): DriveFolderCard[] {
    const children = getChildrenAtPath(this.bookAttrs?.syllabus ?? [], pathIds);
    const parentId = pathIds.length ? pathIds[pathIds.length - 1] : 0;
    return children.map((node) => ({
      id: node.id,
      name: node.name,
      pathIds: [...pathIds, node.id],
      pid: node.pid ?? parentId,
      syllabus_id: node.syllabus_id ?? pathIds[0],
      enabled: this.normalizeFileEnabled(node.enabled),
      cover: node.cover,
    }));
  }

  private toFileCard(row: any): DriveFileCard {
    return {
      id: row.id,
      name: row.name,
      coverUrl: getResourceCoverUrl(row.cover, this.protocol, this.host, this.bucket),
      createdDate: row.created_date?.substring?.(0, 10) ?? row.created_date ?? '',
      enabled: this.normalizeFileEnabled(row.enabled ?? row.reserve3),
      folders: this.mapRowFolders(row),
    };
  }

  private mapRowFolders(row: any): DriveFolderRef[] {
    const rawFolders = Array.isArray(row.folders) ? row.folders : [];
    return rawFolders
      .map((item: { folder_id?: number | string; folder_path?: string | null }) => {
        const id = item.folder_id != null && item.folder_id !== '' ? +item.folder_id : null;
        if (!id) {
          return null;
        }
        return {
          folderId: id,
          folderPath: item.folder_path ?? null,
          folderName: this.resolveFolderName(id),
        };
      })
      .filter((item: DriveFolderRef | null): item is DriveFolderRef => !!item);
  }

  private resolveFolderName(folderId: number): string | null {
    return this.syllabusIdToNode.get(folderId)?.name ?? null;
  }

  private normalizeFileEnabled(value: unknown): number {
    if (value === null || value === undefined || value === '') {
      return 1;
    }
    return +value;
  }

  loadDriveData(): void {
    if (this.destroyed) {
      return;
    }
    const seq = ++this.driveLoadSeq;
    const hasSearch = !!this.filter.name?.trim();
    const hasThemes = hasActiveThemes(this.driveThemes);
    const hasReserve3 = this.filter.reserve3 !== '' && this.filter.reserve3 !== null && this.filter.reserve3 !== undefined;
    const atRoot = this.driveNav.pathIds.length === 0;

    const isDriveSearch = hasSearch;

    this.driveFolderCards = isDriveSearch ? [] : this.buildFolderCards(this.driveNav.pathIds);
    this.driveBreadcrumb = this.driveNav.pathIds.map((id) => ({
      id,
      name: this.syllabusIdToNode.get(id)?.name ?? String(id),
    }));

    if (atRoot && !hasSearch && !hasThemes && !hasReserve3) {
      this.driveFileCards = [];
      this.driveTotal = 0;
      this.driveFilesLoadError = null;
      this.driveContentState = this.driveFolderCards.length ? 'ready' : 'empty';
      return;
    }

    this.driveContentState = 'loading';
    this.driveFilesLoadError = null;
    const query = buildDriveQuery(
      { ...this.filter, themes: this.driveThemes },
      this.driveNav.pathIds
    );
    this.mainService.list(this.resourceType, query).then(({ rows, total }) => {
      if (this.destroyed || seq !== this.driveLoadSeq) {
        return;
      }
      this.driveFileCards = (rows || []).map((row: any) => this.toFileCard(row));
      this.driveTotal = total;
      this.driveContentState = total > 0 || (!isDriveSearch && this.driveFolderCards.length) ? 'ready' : 'empty';
    }).catch(() => {
      if (seq !== this.driveLoadSeq) {
        return;
      }
      this.driveFilesLoadError = '加载失败';
      this.driveContentState = 'error';
    });
  }

  private loadActiveViewData(): void {
    if (this.activeView === 'drive') {
      this.loadDriveData();
      return;
    }
    this.loadData(this.filter);
  }

  private reloadActiveViewData(): void {
    this.loadActiveViewData();
  }
}
